import Page from '../../Routing/Page'
import { SlideOnMount } from '../../Animations'
import { ComponentType, ReactNode, useState } from 'react'
import { OverlayPanel, OverlayQuestionsFooter } from '../../Routing'

export interface GemData {
  key: string
  topic: string
  topicKey: string
  placeholder: boolean
  GemContainer: ReactNode
  Gem: ComponentType<any>
  Detail: ComponentType<any>
  question?: { id: string; defaultMessage: string }
  questions?: { id: string; defaultMessage: string }[]
}

export interface GemGridOverlayPanelProps {
  from: string
  name: string
  title: string
  data: GemData[]
  disableCospo: boolean
}

export const GemGridOverlayPanel = ({ data, from, name, title, disableCospo }: GemGridOverlayPanelProps) => {
  const [disablePanelAnimation, setDisablePanelAnimation] = useState(false)

  return (
    <OverlayPanel
      back={from}
      title={title}
      anchorOffset={125}
      path={`${from}/${name}`}
      onClose={() => setDisablePanelAnimation(false)}
      onOpen={() => setTimeout(() => setDisablePanelAnimation(true), 500)}
      render={({ match, history }) => {
        return data.map((Gem, index) => {
          return (
            <Page
              key={Gem.key}
              path={`${match.url}/${Gem.key.toLowerCase()}`}
              navigation={{
                swipeEnabled: true,
                onPrev: () => {
                  const prevIndex = (data.length + index - 1) % data.length
                  history.replace(`${match.url}/${data[prevIndex].key.toLowerCase()}`)
                },
                onNext: () => {
                  const nextIndex = (index + 1) % data.length
                  history.replace(`${match.url}/${data[nextIndex].key.toLowerCase()}`)
                }
              }}
              render={() => (
                <>
                  <Page.Body>
                    <SlideOnMount disabled={disablePanelAnimation}>
                      <Page.Carousel indicateIndex={index} indicateTotal={data.length}>
                        <Gem.Gem inCarousel />
                      </Page.Carousel>
                    </SlideOnMount>
                    <SlideOnMount disabled={disablePanelAnimation}>
                      <Gem.Detail close={() => history.push(from)} />
                      <Page.Disclaimer />
                    </SlideOnMount>
                  </Page.Body>
                  <Page.Footer key='gem_panel_footer'>
                    <OverlayQuestionsFooter
                      placeholder
                      topic={Gem.topic}
                      topicKey={Gem.topicKey}
                      disableCospo={disableCospo}
                      questions={Gem.questions || [Gem.question]}
                    />
                  </Page.Footer>
                </>
              )}
            />
          )
        })
      }}
    />
  )
}
